<script lang="ts">
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { real_id } from 'src/helpers/interface_helpers';
	import { getDeviceChartsConfig } from 'src/components/Chart/chart_config';
	import ControlVentoraBoost from 'src/components/Controls/Single/ControlVentoraBoost.svelte';
	import ControlVentoraFanSpeed from 'src/components/Controls/Single/ControlVentoraFanSpeed.svelte';
	import ThumbDeviceChartV2 from 'src/components/Chart/ThumbDeviceChartV2.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import { useNavigateToHistoryStatisticsTab } from 'src/components/Sidepanel/useNavigateToHistoryStatisticsTab';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import type { Device } from 'src/types/Device.ts';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;
	$: isVentoraFanAuto = status?.['fan:0']?.mode === 'auto';

	$: deviceChartsConfig = device ? getDeviceChartsConfig(device) : [];

	const { navigateToHistoryStatisticsTab } = useNavigateToHistoryStatisticsTab();

	const handleOnClickThumbChart = (event: CustomEvent | Event) => {
		navigateToHistoryStatisticsTab();
	};
</script>

<DeviceViewStateWrapper {device}>
	<div slot="staticTop">
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<div
		class="flex-full-height align-items-center justify-content-center d-flex flex-direction-column min-height-0"
		slot="staticBottom"
	>
		{#if isVentoraFanAuto}
			<ControlVentoraBoost
				{device}
				{status}
				isWide
				useV2Components={true}
				deviceButtonV2Props={{ size: 'l' }}
			/>
		{:else}
			<ControlVentoraFanSpeed {device} {status} />
		{/if}
	</div>
</DeviceViewStateWrapper>
